export const CATEGORY_TYPE = 'category';
export const TAG_TYPE = 'tag';
